import {
  FINANCING_ORIGIN_ENUM,
  type FinancingOriginValues,
} from 'enums/FinancingOrigin'

export function isFinancingPerValue(origin?: FinancingOriginValues) {
  if (origin) {
    return origin === FINANCING_ORIGIN_ENUM.VALUE
  }

  return false
}

export function isFinancingPerQuotation(origin?: FinancingOriginValues) {
  if (origin) {
    return origin === FINANCING_ORIGIN_ENUM.QUOTATION
  }

  return false
}
